'use client';

import { IconButton, styled, keyframes } from '@mui/material';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
`;

const breathe = keyframes`
  0%, 100% {
    transform: translateX(-50%) scale(1);
    background-color: transparent;
  }
  50% {
    transform: translateX(-50%) scale(1.15);
    background-color: rgba(255, 255, 255, 0.15);

  }
`;

export const StyledScrollDownButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  bottom: 64,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 10,
  width: 64,
  height: 64,
  backgroundColor: 'transparent',
  border: '2px solid white',
  opacity: 0,
  animation: `${fadeInUp} 0.6s ease-out 0.3s forwards, ${breathe} 2s ease-in-out 1.1s infinite`,
  '@media (prefers-reduced-motion: reduce)': {
    opacity: 1,
    animation: 'none',
  },
  [theme.breakpoints.up('sm')]: {
    width: 80,
    height: 80,
  },
}));
